import request from '@/utils/request'

// 字典查询
export function getDictlist(dictType) {
  return request({
    url: `/system/dict/data/list/`,
    method: 'get',
    params: {
      pageNum: 1,
      pageSize: 100,
      dictType: dictType
    }
  })
}
// 省市联动
export function getAreaslevel2() {
  return request({
    url: `/busi/custom/areas/level2`,
    method: 'get',

  })
}
// 获取商户列表数据
export function queryOrgList(query) {
  return request({
    url: '/product/list',
    method: 'get',
    params: query
  })
}

// 获取分销商 
export function getDislist() {
  return request({
    url: `/busi/dis/list`,
    method: 'get',

  })
}
// 查询返费规则
export function getRulelist(query) {
  return request({
    url: '/rebate/rule/list',
    method: 'get',
    params: query
  })
}
// 修改
export function getUpdate(data) {
  return request({
    url: '/goods/update',
    method: 'post',
    data: data
  })
}
// 新增商品 
export function getAdd(data) {
  return request({
    url: '/goods/add',
    method: 'post',
    data: data
  })
}
// 详情
export function getDetailst(id) {
  return request({
    url: `/goods/details`,
    method: 'get',
    params: {
      id: id
    }
  })
}  
